__webpack_require__.hmrF = () => ("training_attestation_app." + __webpack_require__.h() + ".hot-update.json");